import React, {useState} from "react";
import ARIcon from "./../../../ARIcon";
import classNames from "classnames";
import {CInputGroup, CInputGroupAppend, CInputGroupPrepend, CInputGroupText} from "@coreui/react";
import ValidationFeedback from "./../../ValidationFeedback";

const ARPrependAppend = (props) => {
  const {children, className, iconName, prependText, appendText} = props;
  const [error, setError] = useState(null);

  return (
    <CInputGroup className={classNames(className)}>
      {
        (!!prependText || !!iconName) &&
        <CInputGroupPrepend>
          <CInputGroupText>
            {prependText}
            {iconName && <ARIcon name={iconName}/>}
          </CInputGroupText>
        </CInputGroupPrepend>
      }
      {React.isValidElement(children) && React.cloneElement(children, {setError})}
      {
        !!appendText &&
        <CInputGroupAppend>
          <CInputGroupText className="field_right-border-radius">
            {appendText}
          </CInputGroupText>
        </CInputGroupAppend>
      }
      <ValidationFeedback error={error}/>
    </CInputGroup>
  );
};

export default ARPrependAppend;